import React, { useState, useEffect, useCallback, useMemo } from "react";
import Navbar from "../../components/Navbar/Navbar";
import {
  Breadcrumb,
  Button,
  ConfigProvider,
  DatePicker,
  Select,
  Drawer,
  Modal,
} from "antd";
import { DoubleRightOutlined, DownloadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import {
  fetchAllVendors,
  getVendors,
} from "../../API  Functions/PurchaseFunctions";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import { debounce } from "@mui/material";

import { getStoreUsers } from "../../API  Functions/UserMangement";
import SelectBox from "../../components/CustomWidgets/SelectBox";
import moment from "moment";
import dayjs from "dayjs";
import i18next from "i18next";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { toast } from "react-toastify";
import DateFilter from "../../components/ui/DateFilter";
import StockTransferHistoryTable from "./Tables/stockTransferHistoryTable";
import {
  cancelStockTransfer,
  getStockOrderLines,
  GetStockTransferReport,
  UpdateStockTransfer,
} from "../../API  Functions/subStoreFunctions";
import { getSubstores } from "../../API  Functions/ProfileFunctions";
import ExportCasInOutReportModal from "../SessionHistory/ExportCasInOutReportModal";
import dummy_image from "../../assets/Images/gallery.svg";

const StockTransferHistory = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [loading, setloading] = useState(false);
  const { Option } = Select;
  const [data, setData] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(20); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [query, setquery] = useState("");
  const [userData, setUserData] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [stockReport, setStockReport] = useState([]);
  const [searchByShortCode, setSearchByShortCode] = useState(false);
  const location = useLocation();
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const today = dayjs();
  const formatToday = today.format("YYYY-MM-DD");
  const startofMonth = today.startOf("month").format("YYYY-MM-DD");
  const [selectedRange, setSelectedRange] = useState("thisMonth");
  const [startDate, setStartDate] = useState(startofMonth);
  const [endDate, setEndDate] = useState(formatToday);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [subStores, setSubStores] = useState([]);
  const [selectedSubStore, setSelectedSubStore] = useState(null);
  const masterStore = useSelector((state) => state.login.masterStore);
  const [fromStore, setFromStore] = useState(masterStore || null);
  const [searching, setSearching] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [drawerLoading, setDrawerLoading] = useState(false);
  const [drawerData, setDrawerData] = useState(null);
  const [orderLines, setOrderLines] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showAcceptConfirmModal, setShowAcceptConfirmModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [currentRowData, setCurrentRowData] = useState([]);
  const [isFirstFetch, setIsFirstFetch] = useState(true);
  const [searchProductText, setSearchProductText] = useState("");
  const navigate = useNavigate();

  const is_master_Store = useSelector(
    (state) => state?.login?.user?.result?.is_master_store,
  );

  // console.log("stockReport--->", stockReport);

  useEffect(() => {
    if (location.state?.fromNotification && location.state?.id) {
      handleRowClick(location.state);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);
  console.log("count==>", query);

  useEffect(() => {
    if (masterStore) {
      getSubStoresData();
    }
  }, [masterStore]);

  const getSubStoresData = () => {
    getSubstores(masterStore?.store_id).then((res) => {
      setSubStores(res?.response);
    });
  };

  useEffect(() => {
    // Fetch the data whenever 'fromStore' or 'selectedSubStore' changes
    // if (fromStore && selectedSubStore) {
    if (isFirstFetch) {
      setFromStore("");
    }
    GetStockReportData(20, 0, startDate, endDate, query);

    // }
  }, [fromStore, selectedSubStore, startDate, endDate, selectedRange, query]);

  const GetStockReportData = async (
    limit,
    offset,
    start,
    end,
    queryText = "",
  ) => {
    const payload = {
      // parent_store_id: fromStore?.store_id || masterStore?.store_id,
      parent_store_id:
        isFirstFetch || fromStore === ""
          ? ""
          : fromStore?.store_id || masterStore?.store_id,
      child_store_id: selectedSubStore?.store_id,
      offset: offset,
      limit: limit,
      start_date: start,
      end_date: end,
      order_no: searchByShortCode ? "" : queryText,
      short_code: searchByShortCode ? queryText : "",
      status: "",
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
    };
    try {
      const res1 = await GetStockTransferReport(payload);

      if (res1?.result?.status_code === 200) {
        setloading(false);
        setStockReport(res1?.result?.data);
      } else {
        setloading(false);
        setStockReport([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
      setIsFirstFetch(false);
    }
  };

  const handleExport = async (dates) => {
    let payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      start_date: dates?.startDate,
      end_date: dates?.endDate,
      parent_store_id: fromStore?.store_id || null,
      child_store_id: selectedSubStore?.store_id || null, // company_id: compcany_id,
    };
    const response = await axiosInstance.post(
      URLS.GET_STOCK_SUMMARY_EXCEL,
      payload,
    );
    if (response?.data?.result?.status_code == 200) {
      setExportModalOpen(false);
      downloadFile(response?.data?.result?.file_base64);
    } else {
      toast.error(response?.data?.result.status);
    }
  };

  const downloadFile = (base64Data) => {
    try {
      if (
        !base64Data ||
        typeof base64Data !== "string" ||
        base64Data.trim() === ""
      ) {
        alert("No valid file data available for download");
        return;
      }

      let cleanBase64 = base64Data
        .trim()
        .replace(/^data:[\w/+-]+;base64,/, "")
        .replace(/^["']|["']$/g, "")
        .replace(/\s/g, "");

      const padLength = 4 - (cleanBase64.length % 4);
      if (padLength < 4) cleanBase64 += "=".repeat(padLength);

      let binaryString = atob(cleanBase64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const header = new Uint8Array(bytes.buffer, 0, 8);
      let mimeType = "application/octet-stream";
      let fileExtension = "bin";

      if (header[0] === 0x50 && header[1] === 0x4b) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = "xlsx";
      } else if (
        header[0] === 0xd0 &&
        header[1] === 0xcf &&
        header[2] === 0x11 &&
        header[3] === 0xe0
      ) {
        mimeType = "application/vnd.ms-excel";
        fileExtension = "xls";
      } else if (new TextDecoder().decode(header).includes(",")) {
        mimeType = "text/csv";
        fileExtension = "csv";
      }

      const blob = new Blob([bytes], { type: mimeType });
      // const timestamp = new Date()
      //   .toISOString()
      //   .replace(/[:.]/g, "-")
      //   .replace("T", "_")
      //   .slice(0, 19);
      // const filename = `sale_summary_${timestamp}.${fileExtension}`;
      const timestamp = moment().format("YYYY-MM-DD_HH.mm.ss"); // Using period for time
      const filename = `${t(
        "stock_transfer_report",
      )}_${timestamp}.${fileExtension}`;
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("File download failed:", error);
      alert(`Download failed: ${error.message || "Unknown error"}`);
    }
  };

  const handleRowClick = async (order) => {
    setDrawerVisible(true);
    setSearchProductText("");
    setDrawerLoading(true);
    setDrawerData(order);
    setSearchProductText("");

    try {
      const payload = {
        transfer_id: order.id,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      };
      const res = await getStockOrderLines(payload);

      // console.log("STOCK ORDER LINES", res);

      if (res?.result?.status_code === 200) {
        setOrderLines(res?.result?.data || []);
        // console.log("Order Lines Response:", orderLines);
      } else {
        setOrderLines([]);
      }
    } catch (error) {
      console.error("Error fetching order lines:", error);
    } finally {
      setDrawerLoading(false);
    }
  };

  const onClose = () => {
    setDrawerVisible(false);
    setOrderLines([]);
    setSearchProductText("");
  };

  const handleAccept = async (row) => {
    // console.log("Acceptttt", row);
    setloading(true);

    try {
      const payload = {
        transfer_id: row.id,
        status: "Done",
      };
      const res = await UpdateStockTransfer(payload);

      // console.log("STOCK ORDER LINES", res);

      if (res?.result?.status_code === 200) {
        GetStockReportData(20, 0, startDate, endDate);
      } else {
        setOrderLines([]);
        setloading(true);
      }
    } catch (error) {
      console.error("Error fetching order lines:", error);
    } finally {
      setloading(false);
      setShowAcceptConfirmModal(false);
      setCurrentRowData([]);
    }
  };

  const ConfirmCancel = (row) => {
    setShowConfirmModal(true);
    setCurrentRowData(row);
  };

  const ConfirmAccept = (row) => {
    setShowAcceptConfirmModal(true);
    setCurrentRowData(row);
  };
  const handleCancel = async (row) => {
    // console.log("CANCELLL", row);
    setloading(true);

    try {
      const payload = {
        transfer_id: row.id,
        status: "Cancelled",
      };
      const res = await UpdateStockTransfer(payload);

      // console.log("STOCK ORDER LINES", res);

      if (res?.result?.status_code === 200) {
        GetStockReportData(20, 0, startDate, endDate);
      } else {
        setOrderLines([]);
        setloading(true);
      }
    } catch (error) {
      console.error("Error fetching order lines:", error);
    } finally {
      setloading(false);
      setShowConfirmModal(false);
      setCurrentRowData([]);
    }
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      setquery(value); // ✅ only update state
    }, 500),
    [],
  );

  const filteredOrderLines = useMemo(() => {
    if (!searchProductText) return orderLines;

    const q = searchProductText.toLowerCase();

    return orderLines.filter((line) => {
      const barcodeMatch = line.barcode?.toString().toLowerCase().startsWith(q);

      const productShortcutMatch = line.product_shortcut
        ?.toString()
        .toLowerCase()
        .startsWith(q);

      const secondaryBarcodeMatch = line.secondary_barcode
        ?.toString()
        .toLowerCase()
        .startsWith(q);

      const productNameMatch = line.product_name?.toLowerCase().includes(q);

      return (
        barcodeMatch ||
        productShortcutMatch ||
        secondaryBarcodeMatch ||
        productNameMatch
      );
    });
  }, [searchProductText, orderLines]);

  return (
    <>
      <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto  bg-[#F6F7F9]">
        <div>
          <Navbar heading="Stock Transfer Report" />
        </div>
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3">
          {/* From + To Stores Row */}
          {is_master_Store && (
            <div className="flex gap-6 w-1/2 mt-5">
              {/* FROM Store */}
              <div className="w-1/2">
                <label className="block font-medium">{t("From")}</label>
                <Select
                  style={{ width: "100%" }}
                  placeholder={t("Select From Store")}
                  className="h-10 mt-2"
                  value={fromStore?.store_id || null}
                  // disabled={productList.length > 0}
                  onChange={(value) => {
                    const selected =
                      value === masterStore?.store_id
                        ? masterStore
                        : subStores.find((store) => store.store_id === value);
                    setFromStore(selected);
                  }}
                  showSearch
                >
                  {/* Master Store option */}
                  {(!selectedSubStore ||
                    masterStore?.store_id !== selectedSubStore?.store_id) && (
                    <Select.Option
                      key={masterStore?.store_id}
                      value={masterStore?.store_id}
                    >
                      {i18next.language === "ar"
                        ? masterStore?.store_name_ar
                        : masterStore?.store_name}
                    </Select.Option>
                  )}

                  {/* Sub Stores */}
                  {subStores
                    .filter(
                      (store) => store.store_id !== selectedSubStore?.store_id,
                    )
                    .map((store) => (
                      <Select.Option
                        key={store.store_id}
                        value={store.store_id}
                      >
                        {i18next.language === "ar"
                          ? store.store_name_ar
                          : store.store_name}
                      </Select.Option>
                    ))}
                </Select>
              </div>

              {/* TO Store */}
              <div className="w-1/2">
                <label className="block font-medium">{t("To")}</label>
                <Select
                  style={{ width: "100%" }}
                  placeholder={t("Select To Store")}
                  className="h-10 mt-2"
                  // disabled={productList.length > 0}
                  value={selectedSubStore?.store_id}
                  // onChange={(value) => {
                  //   const selected = subStores.find((store) => store.store_id === value);
                  //   setSelectedSubStore(selected);
                  // }}
                  onChange={(value) => {
                    // If master store selected
                    const selected =
                      value === masterStore?.store_id
                        ? masterStore
                        : subStores.find((store) => store.store_id === value);

                    setSelectedSubStore(selected);
                  }}
                  showSearch
                >
                  {/* --- MASTER STORE OPTION --- */}
                  {fromStore?.store_id !== masterStore?.store_id && (
                    <Select.Option value={masterStore?.store_id}>
                      {i18next.language === "ar"
                        ? masterStore?.store_name_ar
                        : masterStore?.store_name}
                    </Select.Option>
                  )}

                  {subStores
                    .filter((store) => store.store_id !== fromStore?.store_id)
                    .map((store) => (
                      <Select.Option
                        key={store.store_id}
                        value={store.store_id}
                      >
                        {i18next.language === "ar"
                          ? store.store_name_ar
                          : store.store_name}
                      </Select.Option>
                    ))}
                </Select>
              </div>
            </div>
          )}
          <div className="flex mt-4 me-8">
            <div className="flex flex-row gap-2 w-full mt-4">
              {/* Search Bar */}
              <div className="">
                <SearchBox
                  // showBarcode={true}
                  searchResult={(values) => debouncedSearch(values)}
                  placeholder={t("Search by Order/Product")}
                />
              </div>
              <button
                type="button"
                onClick={() => {
                  setquery("");
                  // setStockReport([]);
                  setSearchByShortCode(!searchByShortCode);
                }}
                className={`h-[40px] px-2 rounded-md border text-sm whitespace-nowrap ${
                  searchByShortCode
                    ? "bg-blue-100 border-primaryBlue text-primaryBlue"
                    : "bg-white border-gray-300 text-gray-700"
                }`}
              >
                {t("Search Code")}
              </button>

              {/* Date Filter */}
              <div className="-mt-2">
                <DateFilter
                  setSelectedRange={setSelectedRange}
                  selectedRange={selectedRange}
                  SubmitFilter={(start, date) => {
                    setStartDate(start);
                    setEndDate(date);
                    GetStockReportData(
                      currentLimit,
                      currentOffset,
                      start,
                      date,
                      searchText,
                    );
                  }}
                />
              </div>
            </div>

            <div className="flex flex-col items-end  mt-4">
              <button
                className="w-48 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
                onClick={() => setExportModalOpen(true)}
              >
                <DownloadOutlined
                  style={{ fontSize: "1.5em", MozMarginStart: -10 }}
                />
                <span>{t("Download in Excel")}</span>
              </button>

              <span
                onClick={() => {
                  setSelectedRange("thisMonth");
                  // setFromStore(masterStore?.store_id);
                  setFromStore(""); // ✅ pass empty
                  setSelectedSubStore(null);
                  setStartDate(startofMonth);
                  setEndDate(formatToday);
                  setIsFirstFetch(true); // trigger empty parent_store_id in next fetch
                }}
                className="font-semibold text-sm text-primaryBlue cursor-pointer  mt-5 me-4"
              >
                {t("Clear Filter")}
              </span>
            </div>
          </div>
          {loading ? (
            <ShimmerLoader />
          ) : (
            <>
              <div className=" mt-3">
                <StockTransferHistoryTable
                  additionalData={stockReport}
                  pagination={(values) => {
                    // setloading(true)
                    GetStockReportData(
                      values.limit,
                      values.offset,
                      startDate,
                      endDate,
                    );

                    setCurrentLimit(values.limit);
                    setCurrentOffset(values.offset);
                  }}
                  onRowClick={handleRowClick}
                  onAccept={ConfirmAccept}
                  onCancel={ConfirmCancel}
                />
              </div>
            </>
          )}
        </div>

        {/* Drawer */}
        <Drawer
          title={t("Order Details")}
          placement={i18n.language === "ar" ? "left" : "right"}
          width={500}
          onClose={onClose}
          visible={drawerVisible}
          styles={{
            header: {
              color: "#1E3ABA", // Change this to your desired color
              fontWeight: "bold",
              fontSize: "20px",
            },
          }}
        >
          {drawerLoading ? (
            <div className="space-y-4 p-4">
              {/* Header Skeleton */}
              <div className="h-6 bg-gray-200 rounded animate-pulse w-1/2"></div>

              {/* Summary Skeleton */}
              <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse w-2/3"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse w-1/2"></div>
              </div>

              {/* Product Line Skeletons */}
              {[1, 2, 3].map((_, idx) => (
                <div
                  key={idx}
                  className="flex items-center space-x-3 border rounded-lg bg-white p-3 shadow-sm animate-pulse"
                >
                  <div className="w-10 h-10 bg-gray-200 rounded"></div>
                  <div className="flex-1 space-y-2">
                    <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                    <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                  </div>
                  <div className="h-4 bg-gray-200 rounded w-10"></div>
                </div>
              ))}
            </div>
          ) : // <LoadingSpinner />
          // <div>{t("Loading order details...")}</div>
          drawerData ? (
            <div className="space-y-4">
              {/* Order Summary */}
              <div className="space-y-1 text-sm font-medium">
                <p>
                  <strong>{t("Order No. :")}</strong> {drawerData.currency}{" "}
                  {drawerData.order_no}
                </p>
                <p>
                  <strong>{t("Number of Items :")}</strong>{" "}
                  {drawerData.no_of_items || orderLines?.length}
                </p>
                {/* <p>
                    <strong>{t("Payment Mode :")}</strong>{" "}
                    {drawerData.payment || "-"}
                  </p> */}
                <p>
                  <strong>{t("Status :")}</strong>{" "}
                  {drawerData.status === "Draft"
                    ? t("In Transit")
                    : drawerData.status === "Done"
                      ? t("Received")
                      : drawerData.status === "Cancelled"
                        ? t("Cancelled")
                        : "-"}
                </p>
              </div>
              <SearchBox
                width={"100%"}
                // showBarcode={true}
                searchResult={(value) => setSearchProductText(value)}
                placeholder={t("Search Products")}
              />
              {/* Product Lines */}
              <div>
                {filteredOrderLines.length === 0 ? (
                  <div className="text-center text-gray-500 text-sm py-6">
                    {t("No product found")}
                  </div>
                ) : (
                  <>
                    {filteredOrderLines.map((line, index) => (
                      <div
                        key={index}
                        className=" border rounded-lg bg-white p-2 mb-2 shadow-sm"
                      >
                        <div className="flex justify-between items-center">
                          {/* Image */}
                          <div className=" flex items-center">
                            {line.image_url ? (
                              <img
                                src={line.image_url || "/placeholder.png"}
                                alt={""}
                                className="w-10 h-10 object-contain rounded"
                              />
                            ) : (
                              <img
                                src={dummy_image}
                                alt=""
                                className="w-10 h-10 object-contain rounded"
                              />
                            )}

                            {/* Middle content: Name + Qty x Price */}
                            <div className="flex flex-col flex-1 mx-2">
                              <p className="font-semibold text-sm leading-tight">
                                {line.product_name}
                              </p>
                              <p className="text-sm text-gray-600">
                                {line.barcode}
                              </p>
                            </div>
                          </div>
                          {/* Right: Total price */}
                          <div className="flex flex-col justify-center items-center">
                            <p className="font-normal whitespace-nowrap text-right">
                              {t("Qty")}
                            </p>
                            <p className="font-normal whitespace-nowrap text-right">
                              {line.transfer_quantity}
                            </p>
                          </div>
                        </div>
                        {(line.product_shortcut || line.secondary_barcode) && (
                          <div className=" mt-1 ms-12">
                            {line.secondary_barcode && (
                              <div className="flex items-center">
                                <p className="font-normal whitespace-nowrap text-right">
                                  {t("Secondary Barcode")}:
                                </p>
                                <p className="font-normal whitespace-nowrap text-right">
                                  {line.secondary_barcode || "-"}
                                </p>
                              </div>
                            )}
                            {line.product_shortcut && (
                              <div className="flex items-center">
                                <p className="font-normal whitespace-nowrap text-right">
                                  {t("Product Short Code")}:
                                </p>
                                <p className="font-normal whitespace-nowrap text-right">
                                  {line.product_shortcut || "-"}
                                </p>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          ) : (
            <p>{t("no_product_found")}</p>
          )}
        </Drawer>

        <Modal
          open={showConfirmModal}
          onCancel={() => {
            setCurrentRowData([]);
            setShowConfirmModal(false);
          }}
          footer={null}
          centered
          closable={false}
        >
          <div className="text-center p-6">
            <h3 className="text-lg font-semibold mb-4 text-gray-800">
              {t("Are you sure you want to cancel the transfer?")}
            </h3>
            <div className="flex justify-center gap-4 mt-6">
              <button
                onClick={() => {
                  setCurrentRowData([]);
                  setShowConfirmModal(false);
                }}
                className="px-6 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 text-gray-700 font-semibold"
              >
                {t("No")}
              </button>
              <button
                onClick={() => handleCancel(currentRowData)} // ✅ fixed line
                disabled={loading}
                className="px-6 py-2 rounded-lg bg-[#FF1616] hover:bg-[#e01414] text-white font-semibold"
              >
                {loading ? t("Removing...") : t("Yes")}
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          open={showAcceptConfirmModal}
          onCancel={() => {
            setCurrentRowData([]);
            setShowAcceptConfirmModal(false);
          }}
          footer={null}
          centered
          closable={false}
        >
          <div className="text-center p-6">
            <h3 className="text-lg font-semibold mb-4 text-gray-800">
              {t("Are you sure you want to accept this transfer?")}
            </h3>
            <div className="flex justify-center gap-4 mt-6">
              <button
                onClick={() => {
                  setCurrentRowData([]);
                  setShowAcceptConfirmModal(false);
                }}
                className="px-6 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 text-gray-700 font-semibold"
              >
                {t("No")}
              </button>
              <button
                onClick={() => handleAccept(currentRowData)} // ✅ fixed line
                disabled={loading}
                className="px-6 py-2 rounded-lg bg-primaryBlue hover:bg-[#122e65] text-white font-semibold"
              >
                {loading ? t("Adding...") : t("Yes")}
              </button>
            </div>
          </div>
        </Modal>

        {exportModalOpen && (
          <ExportCasInOutReportModal
            heading={t("Download Stock Transfer Report")}
            isOpen={exportModalOpen}
            onClose={() => setExportModalOpen(false)}
            onExport={(dates) => handleExport(dates)}
          />
        )}
      </div>
    </>
  );
};

export default StockTransferHistory;
